import React, { useState } from 'react'
import { Box, useColorModeValue } from '@chakra-ui/react'

import NavigationBar from '../Components/NavigationBar'
import Footer from '../Components/Footer'
import { Hero, FaqList } from '../Features/Faq'

import GlobalAlertDialog from '../Components/Elements/GlobalAlertDialog'

export const meta = () => {
  return [
    {
      title: 'daddysteach - Frequently Asked Questions'
    },
    {
      name: 'description',
      content: 'Find answers to your questions on our FAQ page. Get the information you need about our services, policies, and more. Visit now to learn more.'
    }
  ]
}

const Faq = () => {
  const backgroundColor = useColorModeValue('gray.50', 'gray.900')
  const [query, setQuery] = useState('')

  return (
    <Box bgColor={backgroundColor}>
      <NavigationBar />
      <GlobalAlertDialog />
      <Hero query={query} setQuery={setQuery} />
      <FaqList query={query} setQuery={setQuery} />
      <Footer />
    </Box>
  )
}

export default Faq